import { useMemo } from 'react';

import { hasAnyCCRCCompetitor, isCommunityCCRC } from 'components/Community/utils';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { createContractsByCommunityMap } from 'components/View/filters/CustomCommunityContractTypeFilter/helpers';
import { CommunityContractSelectionType } from 'components/View/filters/CustomCommunityContractTypeFilter/types';

export const useCommunityContractSelection = () => {
  const { community, competitors, viewFilters } = useCommunityViewContext();

  const selection = useMemo<CommunityContractSelectionType | undefined>(
    () => (viewFilters as any)?.communityContractSelection,
    [viewFilters]
  );

  const isFilterApplicable = useMemo(() => {
    if (!community) {
      return false;
    }
    if (isCommunityCCRC(community?.rental_types)) {
      return false;
    }
    return hasAnyCCRCCompetitor(competitors ?? []);
  }, [community, competitors]);

  const contractsByCommunity = useMemo(() => {
    if (!isFilterApplicable) {
      return {};
    }
    return createContractsByCommunityMap({ community, competitors, selection });
  }, [community, competitors, selection, isFilterApplicable]);

  const communityContractIds = useMemo<number[] | null>(() => {
    if (!isFilterApplicable) {
      return null;
    }
    const ids = Object.values(contractsByCommunity);
    return ids.length ? ids : null;
  }, [isFilterApplicable, contractsByCommunity]);

  return {
    isFilterApplicable,
    selection,
    contractsByCommunity,
    communityContractIds,
  };
};

export default useCommunityContractSelection;
